import { render, staticRenderFns } from "./tiktoklisting.vue?vue&type=template&id=0dc3a316&scoped=true&"
import script from "./tiktoklisting.vue?vue&type=script&lang=js&"
export * from "./tiktoklisting.vue?vue&type=script&lang=js&"
import style1 from "./tiktoklisting.vue?vue&type=style&index=1&id=0dc3a316&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3a316",
  null
  
)

export default component.exports